<template>
  <div class="root-container">
    <div class="container">
      <h1>
        <img src="public/images/title.png" alt="" />
      </h1>
      <div class="illustration">
        <img src="public/images/denjiro_explanation01.png" alt="" />
      </div>
      <template v-if="loading"></template>
      <template v-else>
        <router-link
          class="base-button"
          to="/quiz"
          v-on:click.native="playSound('tap_start')"
          >スタート</router-link
        >
        <p class="footer-link"><a :href="siteUrl">サイトトップにもどる</a></p>
      </template>
    </div>
    <Copyright />
  </div>
</template>

<script>
import axios from 'axios';
import QuizModel from '../scripts/QuizModel';
import ImageLoader from '../scripts/ImageLoader';
import SoundController from '../scripts/SoundController';

export default {
  name: 'Home',
  data() {
    return {
      loading: this.loading,
      siteUrl: window.siteUrl,
    }
  },
  methods: {
  },
  created: async function () {
    this.loading = true;
    if (!SoundController.isLoaded) {
      await SoundController.load();
    }
    if (!ImageLoader.isLoaded) {
      await ImageLoader.start();
    }
    if (!QuizModel.isInitialized) {
      const response = await axios.get('./public/data.json');
      QuizModel.init(response.data);
    }
    this.loading = false;
  },
  mounted: function () {
    if (QuizModel.isInitialized) QuizModel.renew();
  }
}
</script>

<style scoped>
.container {
  text-align: center;
}
.illustration {
  margin-bottom: 20px;
}
</style>
